export const EMAIL_DESIGN_TYPE = {
    EMAIL: 'email',
    EMAIL_BLOCK: 'email_block',
};
export const REUSABLE_SECTION = 'reusableSection';
  